import { Injectable } from '@angular/core';
import { Branching } from 'app/modules/domain/models/branching';
import { Observable } from 'rxjs/Observable';
import { BranchingApiService } from './branching.api.service';

@Injectable()
export class BranchingDomainService {
    constructor(private brnachingService: BranchingApiService) { }

    getBranchingData(fromData: Date, toDate: Date, jobId: string): Observable<{} | Branching> {
        return this.brnachingService.getBranchingData(fromData, toDate, jobId);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/components/branching-container/services/branching.domain.service.ts